import axios from 'axios'
import store from "@/store";

export default {
    state: {
        userReviewUserExpectations: [],
        userReviewRatingImproves: [],
        userReviewRatingLikes: [],
        reviewRating: [],
        userReviewRating: []
    },
    getters: {
        userReviewUserExpectations(state) {
            return state.userReviewUserExpectations;
        },
        userReviewRatingImproves(state) {
            return state.userReviewRatingImproves
        },
        userReviewRatingLikes(state) {
            return state.userReviewRatingLikes
        },
        reviewRating(state) {
            return state.reviewRating
        },
        userReviewRating(state) {
            return state.userReviewRating
        }
    },

    actions: {
        async getUserReviewUserExpectations({ commit }) {
            const res = await axios.get("user/review/user-expectations");

            const data = res && res.data && res.data.data;
            commit("setUserReviewUserExpectations", data);
        },

        async getUserReviewRatingImproves({ commit }, { rating }) {
            const res = await axios.get(`user/review/rating-improves/${rating}`);

            const data = res && res.data && res.data.data;
            commit("setUserReviewRatingImproves", data);
        },

        async getUserReviewRatingLikes({ commit }) {
            const res = await axios.get(`user/review/rating-likes`);

            const data = res && res.data && res.data.data;
            commit("setUserReviewRatingLikes", data);
        },

        async postReviewRating({ commit }, payload) {
            const res = await axios.post("user/review/rating", payload);

            store.commit("setIsSuccess", res && res.data && res.data.message);

            const data = res && res.data && res.data.data;
            commit("setReviewRating", data);
        },

        async putReviewRating({ commit }, payload) {
            const res = await axios.put("user/review/rating", payload);

            store.commit("setIsSuccess", res && res.data && res.data.message);

            const data = res && res.data && res.data.data;
            commit("setReviewRating", data);
        },

        async getUserReviewRating({ commit }, { session_id, query }) {
            // const res = await axios.get(`user/review/rating/${payload.session_id}?entity_type=${payload.entity_type}`);
            const res = await axios.get(`user/review/rating/${session_id}`, { params: query });

            const data = res && res.data && res.data.data;
            commit("setUserReviewRating", data);
        },

        async deleteUserReviewRating({ commit }, { rating_id }) {
            const res = await axios.delete(`user/review/rating/${rating_id}`);

            store.commit("setIsSuccess", res && res.data && res.data.message);
        },
        async getSessionReviews(context, payload) {
            try {
              const response = await axios.get(`user/review/session/${payload}`);
              return response.data && response.data.data;
            } catch (error) {
              console.log(error);
            }
        }
    },
    mutations: {
        setUserReviewUserExpectations(state, data) {
            state.userReviewUserExpectations = data;
        },
        setUserReviewRatingImproves(state, data) {
            state.userReviewRatingImproves = data
        },
        setUserReviewRatingLikes(state, data) {
            state.userReviewRatingLikes = data
        },
        setReviewRating(state, data) {
            state.reviewRating = data
        },
        setUserReviewRating(state, data) {
            state.userReviewRating = data
        },
    }
}